import GET from "./GET";
const inDesktopOnly = Number(GET("innerWidth")) > 600;
export default inDesktopOnly;
